var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Snackbar, Slide, SnackbarContent, Portal } from '@mui/material';
import Text from '../Text';
import { useRef } from 'react';
import { getBannerColors } from '../../utils/banner/getBannerColors';
var DEFAULT_DELAY = 5000;
// https://mui.com/components/snackbars/#control-slide-direction
function TransitionUp(props) {
    return _jsx(Slide, __assign({}, props, { direction: "up" }));
}
export default function Toaster(props) {
    var _a = props.delay, delay = _a === void 0 ? DEFAULT_DELAY : _a, _b = props.closeOnClickOutside, closeOnClickOutside = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? 'success' : _c, onClose = props.onClose, open = props.open, message = props.message;
    var id = useRef(Date.now()).current;
    var styles = getBannerColors('success');
    var clickAwayListenerProps = closeOnClickOutside ? { onClickAway: onClose } : undefined;
    if (variant === 'warning')
        styles = getBannerColors('warning');
    if (variant === 'error')
        styles = getBannerColors('error');
    if (variant === 'info')
        styles = getBannerColors('info');
    styles = __assign(__assign({}, styles), { minWidth: 'unset !important', borderWidth: 2, borderStyle: 'solid', borderRadius: '8px', boxShadow: '0px 2px 4px 2px rgba(82, 99, 99, 0.12)' });
    return (_jsx(Portal, { children: _jsx(Snackbar, __assign({ anchorOrigin: { horizontal: 'center', vertical: 'bottom' }, open: open, TransitionComponent: TransitionUp, autoHideDuration: delay, onClose: onClose, ClickAwayListenerProps: clickAwayListenerProps }, { children: _jsx(SnackbarContent, { message: _jsx(Text, __assign({ variant: "body2", color: "neutral100" }, { children: _jsx("span", { dangerouslySetInnerHTML: { __html: message } }) })), sx: styles }) }), id) }));
}
